import React from "react";

const SecurityPersonal = () => {
  return (
    <div className="container mx-auto">
      <div className="flex justify-between">
        <h1 className="mx-4 pb-8 text-gray-500 text-xl font-bold">
          Security personnel trained in human rights policies or procedures
        </h1>
        <h3 className="text-end mx-8 bg-gray-200 font-bold text-sm h-[3%] border-4 h-12 w-[10%]">
          GRI 410-1
        </h3>
      </div>
      <table className="border-collapse border mx-4 ">
        <tr>
          <th rowSpan="2" className="w-[20%]"></th>
          <th rowspan="2" className="border text-sm px-4 w-[25%] py-2">
            Number of Security Personnel
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[25%] py-2">
            Employees of the Organization
          </th>
          <th rowspan="2" className="border text-sm px-4 w-[25%] py-2">
            Employees of third-party organizations
          </th>
        </tr>
        <tr>
          {/* <th className="border text-xs font-bold px-4 py-4">Male</th>
          <th className="border text-xs font-bold px-4 py-4">Female</th>
          <th className="border text-xs font-bold px-4 py-4">Non-Binary</th> */}
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            Operation
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className=" px-1 py-2 text-xs">
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="8"
            ></input>
          </td>
        </tr>
        <tr>
          <td className="border text-xs font-bold px-4 py-4 text-center">
            +Add Category
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="10"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
          <td className="  px-1 py-2 text-xs">
            {" "}
            <input
              className="w-full border m-auto flex justify-center items-center text-center py-2"
              placeholder="12"
            ></input>
          </td>
        </tr>
      </table>

      <div className="flex items-center mx-4 pb-2 mt-8 mb-4">
        <div className="w-full mr-2">
          <label htmlFor="legalForm" className="block font-bold mb-1 pb-4">
            <h2 className="text-gray-600">
              Specify if training requirements apply to third-party
              organizations providing security personnel.
            </h2>
          </label>
          <select
            // id="natureofOwnership"
            name="natureofOwnership"
            className="mt-2 p-2 border rounded-md w-full"
            // value={formData.natureofOwnership}
            // onChange={handleInputChange}
          >
            <option value="select">- Select - </option>
            <option value="yes">Yes</option>
            <option value="no">No</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default SecurityPersonal;
